import moment from 'moment';

/**
 * 날짜 포맷 함수
 *
 * value: 포맷할 날짜
 * - ISO 문자열: '2025-06-09'
 * - Date 객체: new Date()
 * - timestamp (ms): 1717891200000
 *
 * format: 원하는 날짜 포맷 (기본값: 'YYYY-MM-DD')
 */
export const formatDate = (value, format = 'YYYY-MM-DD') => {
  const momentDate = moment(value);
  return momentDate.isValid() ? momentDate.format(format) : null;
};

/**
 * 날짜 포맷 (yyyy.mm.dd)
 *
 * dt: '2025-11-25T17:08:03' → '2025.11.25'
 */
export const formatDateYmd = (dt) => {
  if (!dt) return '';
  const d = new Date(dt);
  const y = d.getFullYear();
  const m = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${y}.${m}.${day}`;
};

/**
 * 날짜 포맷 (YYYYMMDD) - 택일 로직 전용
 */
export const toDateStr = (date) => {
  if (!date) return '';
  // date가 Date 객체가 아닐 경우 처리
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}${m}${day}`;
};

/**
 * 월 포맷 (YYYYMM) - 택일 로직 전용
 */
export const toMonthStr = (date) => {
  if (!date) return '';
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  return `${y}${m}`;
};

/**
 * D-Day 계산
 *
 * expiryDate: 만료일 (ISO 문자열 또는 Date 객체)
 * withPrefix: true → 'D-7', false → '7'
 */
export const calculateDDay = (expiryDate, withPrefix = true) => {
  if (!expiryDate) return withPrefix ? 'D-0' : '0';

  const today = new Date();
  const expiry = new Date(expiryDate);
  const diffTime = expiry - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) return withPrefix ? 'D-0' : '0';
  return withPrefix ? `D-${diffDays}` : `${diffDays}`;
};
